// extracted by mini-css-extract-plugin
var _1 = "field-input-error__fXd7t";
export { _1 as "fieldInputError" }
